import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { string } from 'prop-types';
import Scrollbar from 'react-scrollbars-custom';
import Modal from 'sub_components/Common/PortalModalNew';
import FileUpload from '../Common/FileUpload';

import { AttachmentApi } from '../../services/attachment';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const EditIconDefault = `${CDN_URL}common/icon-edit-default-lg.svg`;
const EditIconHover = `${CDN_URL}common/icons-edit-selected-lg.svg`;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;
const UploadImageSelected = `${CDN_URL}support/ticketing/upload-icon-activated-lg.svg`;
const UploadImageDefault = `${CDN_URL}support/ticketing/upload-icon-default-lg.svg`;
const UploadImageHover = `${CDN_URL}support/ticketing/upload-icon-hover-lg.svg`;
const UploadImageForm = `${CDN_URL}support/ticketing/attachment-icon-form-selected-lg.svg`;

class UploadSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			attachments: null,
			error: null,
			scannedAttachmentIds: [],
			errorAttachmentIds: [],
			attachmentsComplete: false,
			uploaded: false,
		};
	}
	blobToBase64 = blob => {
		return new Promise(resolve => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.readAsDataURL(blob);
		});
	};

	onDrop = async acceptedFiles => {
		this.setState({ error: null });
		const response = new Promise(resolve => {
			acceptedFiles.forEach((file, index) => {
				const reader = new FileReader();
				reader.onload = () => {
					const fileAsArrayBuffer = reader.result;
					const attachment = {
						id: `${file.lastModified}`,
						filename: file.name,
						size: file.size,
						file: fileAsArrayBuffer,
						type: file.type,
						percentComplete: 0,
						speed: '0 kb / sec',
					};
					if (AttachmentApi.isValidAttachmentType(attachment)) {
						this.setState(
							state => {
								// eslint-disable-next-line
								state.attachments = state.attachments || [];
								state.attachments.push(attachment);
								return state;
							},
							() => this.onAttach(),
						);
					} else {
						this.setState(
							state =>
								// eslint-disable-next-line
								(state.error = `Sorry, we do not support uploads of type ${attachment.type}`),
						);
					}
					if (acceptedFiles.length - 1 === index) {
						resolve();
					}
				};
				reader.onabort = () => console.log('file reading was aborted');
				reader.onerror = () => console.log('file reading has failed');

				reader.readAsArrayBuffer(file);
			});
		});
		console.log(response);
	};

	onRemove = id => {
		const { scannedAttachmentIds } = this.state;
		const { saveAttachments, updateData, phase } = this.props;
		const attachmentMatches = scannedAttachmentIds.filter(att => att.id === id);

		if (attachmentMatches && attachmentMatches.length === 1) {
			const index = scannedAttachmentIds.indexOf(attachmentMatches[0]);
			const updatedAttachments = [...scannedAttachmentIds];
			updatedAttachments.splice(index, 1);

			if (phase === 'edit') {
				updateData('issue', 'attachments', updatedAttachments);
			} else {
				saveAttachments(updatedAttachments, 'remove');
			}
			this.setState({ scannedAttachmentIds: updatedAttachments });
		}
	};
	onAttach = async () => {
		const { attachments } = this.state;
		let scannedAttachmentIds = [];
		const errorAttachmentIds = [];

		if (attachments && attachments.length < 1) {
			this.setState({ error: 'No new tickets uploaded yet!' });
			return;
		}
		attachments.forEach(async (attachment, index) => {
			const { file, type } = attachment;
			const intervals = {};
			let sendAttachment = null;
			let retrieveFile;

			if (file) {
				sendAttachment = await AttachmentApi.sendAttachment(file, type);
			}
			const { data: { data_id } = {} } = sendAttachment;

			if (sendAttachment.status === 200 && data_id) {
				intervals[index] = setInterval(async () => {
					retrieveFile = await AttachmentApi.getFileStatusFromML(data_id);

					if (retrieveFile.status === 200) {
						scannedAttachmentIds = this.checkScannedAttachmentIDs(
							retrieveFile,
							attachment,
							index,
							scannedAttachmentIds,
							intervals,
							errorAttachmentIds,
						);
					} else {
						errorAttachmentIds.push({ ...attachment, file: null, error: `Failure scanning file` });
					}
				}, 2000);

				setTimeout(() => {
					if (intervals[index]) {
						clearInterval(intervals[index]);
						intervals[index] = false;
					}
				}, 30000);
			} else {
				errorAttachmentIds.push({ ...attachment, file: null, error: `Scan Id retrieval error` });
				this.checkFileAttachmentCompletion(scannedAttachmentIds, errorAttachmentIds, attachments);
			}
		});
	};

	checkScannedAttachmentIDs = (
		retrieveFile,
		attachment,
		index,
		scannedAttachmentIds,
		intervals,
		errorAttachmentIds,
	) => {
		const { attachments } = this.state;
		if (
			retrieveFile.data.process_info &&
			retrieveFile.data.process_info.progress_percentage === '100'
		) {
			this.updateFileUploadProgress(attachment.id);
			if (
				retrieveFile.data.sanitized.result === 'Processing' ||
				retrieveFile.data.sanitized.result === 'Allowed'
			) {
				clearInterval(intervals[index]);
				//intervals[index] = false;
				const { data: { data_id } = {} } = retrieveFile;

				if (!scannedAttachmentIds.some(attachment => attachment.data_id === data_id)) {
					scannedAttachmentIds.push({
						...attachment,
						file: attachment.file,
						data_id,
						percentComplete: 100,
						success: true,
					});

					this.savingAttachment(scannedAttachmentIds);
				}

				this.checkFileAttachmentCompletion(scannedAttachmentIds, errorAttachmentIds, attachments);
			} else {
				clearInterval(intervals[index]);
			}
		}

		return scannedAttachmentIds;
	};

	savingAttachment = scannedAttachmentIds => {
		const { saveAttachments, updateData, phase, attachments: existingAttachments } = this.props;
		setTimeout(() => {
			if (phase === 'edit') {
				const existingArray = existingAttachments.concat(scannedAttachmentIds);
				updateData('issue', 'attachments', existingArray);
			} else {
				saveAttachments(scannedAttachmentIds);
			}

			this.toggleModal();
		}, 1000);
	};

	checkFileAttachmentCompletion = (successes, errors, attachments) => {
		const { scannedAttachmentIds: existingAttachments } = this.state;

		const filteredArray = [];
		successes.forEach(attachment => {
			if (existingAttachments.some(existingAttachment => existingAttachment.id === attachment.id)) {
			} else {
				filteredArray.push(attachment);
			}
		});

		if (successes.length + errors.length === attachments.length) {
			if (successes.length === 0 && errors.length > 0) {
				let err = '';

				errors.map(error => {
					return (err += `\n${error.filename} - ${error.error}`);
				});

				this.setState({ error: `Ticket upload failed.${err}`, errorAttachmentIds: errors });
			} else if (successes.length >= 0 || errors.length > 0) {
				setTimeout(() => {
					this.setState({
						attachments: [],
						scannedAttachmentIds: existingAttachments.concat(filteredArray),
						errorAttachmentIds: errors,
					});
				}, 1000);
			}
		}
	};

	renderBrowseButton = () => {
		const { uploaded } = this.state;
		return (
			<Dropzone onDrop={this.onDrop} disableClick>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()}>
						<input {...getInputProps()} data-cy='attachment-input' />
						<div className='icon'>
							<img
								src={UploadImageDefault}
								alt='upload'
								onClick={() => {
									this.setState({ open: true });
								}}
								onMouseEnter={e =>
									(e.currentTarget.src = uploaded ? UploadImageSelected : UploadImageHover)
								}
								onMouseLeave={e =>
									(e.currentTarget.src = uploaded ? UploadImageSelected : UploadImageDefault)
								}
							/>
						</div>
					</div>
				)}
			</Dropzone>
		);
	};
	renderBrowseButtonSmall = () => {
		return (
			<Dropzone onDrop={this.onDrop} disableClick>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()}>
						<input {...getInputProps()} data-cy='attachment-input-small' />
						<div className='icon'>
							<img
								src={UploadImageForm}
								alt='upload'
								onClick={() => {
									this.setState({ open: true });
								}}
							/>
						</div>
					</div>
				)}
			</Dropzone>
		);
	};

	renderEditIcon = () => {
		return (
			<Dropzone onDrop={this.onDrop} disableClick>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()}>
						<input {...getInputProps()} />
						<div className='edit-icon'>
							<img
								src={EditIconDefault}
								onMouseOver={e => {
									e.currentTarget.src = EditIconHover;
								}}
								onMouseOut={e => {
									e.currentTarget.src = EditIconDefault;
								}}
								alt='upload'
								onClick={() => {
									this.setState({ open: true });
								}}
							/>
						</div>
					</div>
				)}
			</Dropzone>
		);
	};
	removeDuplicates = (arr, comp) => {
		const unique = arr
			.map(e => e[comp])
			.map((e, i, final) => final.indexOf(e) === i && i)
			.filter(e => arr[e])
			.map(e => arr[e]);

		return unique;
	};

	renderAttachments = () => {
		const {
			attachments: currentAttachments,
			scannedAttachmentIds: existingAttachments,
			errorAttachmentIds,
		} = this.state;

		let newAttachments = [];
		if (currentAttachments) {
			newAttachments = currentAttachments;
		}
		let attachments =
			newAttachments || existingAttachments ? newAttachments.concat(existingAttachments) : [];
		attachments = this.removeDuplicates(attachments, 'id');

		return attachments.reverse().map(attachment => {
			let error = null;
			const fileDetails = {
				title: attachment.filename,
				percentComplete: attachment.percentComplete
					? attachment.percentComplete
					: Math.floor(Math.random() * 40) + 1,
				speed: attachment.speed,
				size: attachment.size,
			};
			if (errorAttachmentIds && errorAttachmentIds.length !== 0) {
				error = errorAttachmentIds.filter(error => error.id === attachment.id);
			}

			return (
				<FileUpload
					key={attachment.id}
					id={attachment.id}
					file={attachment}
					fileDetails={fileDetails}
					remove={this.onRemove}
					error={error}
				/>
			);
		});
	};

	initalizeState = attachments => {
		this.setState({
			open: false,
			uploaded: true,
			scannedAttachmentIds: attachments,
			attachments: [],
		});
	};

	toggleModal = () => {
		const { scannedAttachmentIds } = this.state;
		const { phase, attachments } = this.props;

		if (scannedAttachmentIds.length !== 0 || (phase === 'edit' && attachments.length !== 0)) {
			this.setState({ open: false, uploaded: true });
		} else {
			this.setState({ open: false, uploaded: false });
		}
	};

	componentDidUpdate() {
		const { attachments } = this.props;
		const { uploaded } = this.state;

		if (attachments && attachments.length > 0 && !uploaded) {
			this.initalizeState(attachments);
		}
	}
	updateFileUploadProgress = () => file => {
		const { attachments } = this.state;
		const matchingAttachmentIndex = attachments.indexOf(file);

		if (matchingAttachmentIndex !== -1) {
			attachments[matchingAttachmentIndex] = {
				...attachments[matchingAttachmentIndex],
				percentComplete: 100,
			};
			this.setState({ attachments });
		}
	};

	componentDidMount() {
		const { attachments } = this.props;

		if (attachments && attachments.length > 0) {
			this.initalizeState(attachments);
		}
	}
	renderUploadBody = uploaded => {
		const { title, phase } = this.props;
		const { open, error } = this.state;

		return (
			<>
				{phase !== 'edit' && (
					<div className='top-upload-section'>
						{uploaded && this.renderBrowseButtonSmall()}
						<div className={uploaded ? 'title  heading60' : 'title  heading60 center'}>
							{uploaded ? 'ATTACHMENTS' : title}
						</div>
						{/* <div className='status body-copy-small-regular'>{this.getUploadCount()}</div> */}
					</div>
				)}

				{phase === 'edit' && this.renderEditIcon()}
				<div className='bottom-upload-section'>
					{!uploaded && phase !== 'edit' && this.renderBrowseButton()}
					<div className={`upload-wrapper ${open && !uploaded ? 'open' : 'closed'}`}>
						{open && (
							<Modal>
								<div className='upload-content'>
									<div className='upload-content-container'>
										<div className='upload-header'>
											<div className='image'>
												<img src={UploadImageDefault} />
											</div>
											<div className='title heading60'>Your files are loading.</div>
											<div className='cancel-button' onClick={this.toggleModal}>
												<img src={CloseIcon} />
											</div>
											{error && <div className='error body10'> {error}</div>}
										</div>
										<div className='upload-body'>
											<Scrollbar disableTracksWidthCompensation noScrollX>
												{this.renderAttachments()}
											</Scrollbar>
										</div>
									</div>
								</div>
							</Modal>
						)}
					</div>
					{uploaded && (
						<div className='upload-content-attachments'>
							<div className='upload-content-container-attachments'>
								<div className={'upload-wrapper open'}>
									<div className='upload-body uploaded'>
										<Scrollbar disableTracksWidthCompensation noScrollX>
											{this.renderAttachments()}
										</Scrollbar>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</>
		);
	};

	render() {
		const { uploaded } = this.state;
		const { phase } = this.props;

		return <div className={`upload-section ${phase}`}>{this.renderUploadBody(uploaded)}</div>;
	}
}

UploadSection.propTypes = {
	title: string,
};

UploadSection.defaultProps = {
	title: 'Attach a file.',
};

export default UploadSection;
